import clsx from "clsx";
import { PropsWithChildren } from "react";
import { TextButtonProps, TextLinkType } from "../../types";
import { getLinkStyles } from "../../helpers";

export function TextButton({
  className,
  size,
  linkType = TextLinkType.primary,
  ...props
}: PropsWithChildren<TextButtonProps>) {
  return (
    <button
      className={clsx(getLinkStyles({ linkType, size }), className)}
      {...props}
    >
      {props.children}
    </button>
  );
}
